import { requestGet, requestPost } from '@/utils/request';

// 鉴权
export function getAuth() {
  return requestGet(`/v2/camp/api/marking/auth`, {});
}

// 待批阅或已批阅分页
export function getPage(params: any) {
  return requestPost(`/v2/camp/api/marking/page`, params);
}

// 列出批阅主观题
export function listSubjectiveQuestion(studyNodeId: string) {
  return requestGet(`/v2/camp/api/marking/list/subjective/${studyNodeId}`, {});
}

// 保存或提交主观题
export function saveSubjectiveQuestion(params: any) {
  return requestPost(`/v2/camp/api/marking/save`, params);
}

// 列举筛选器所需的数据
export function listFilters(params: any) {
  return requestPost(`/v2/camp/api/marking/list/filters`, params);
}
